import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ChatbotWidgetContext } from 'components/ChatbotWidget/utils/ChatbotWidgetContext';
import { Typography, Icon, Skeleton } from 'gd-design-library';
import { Button } from 'components/baseComponents/Button';
import { View } from 'components/ChatbotWidget/constants/view';
import styles from './CallSubmitted.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const CN = 'call-submitted';

export const CallSubmitted = (): React.ReactElement => {
  const { setView, client, options } = useContext(ChatbotWidgetContext);
  const [ waitTimeSeconds, setWaitTimeSeconds ] = useState<number | null>(null);

  const startNewConversation = useCallback(async () => {
    setView(View.SELECT_CONTACT_OPTION);
  }, [ setView ]);

  useEffect(() => {
    const fetchWaitTime = async (): Promise<void> => {
      if (!client) return;
      const waitTimes = await client.getWaitTimes(options.menuId);
      setWaitTimeSeconds(waitTimes.voice_call);
    };
    fetchWaitTime();
  }, [ client, options.menuId ]);

  return (
    <div className={ cx(CN) }>
      <div>
        <Typography align='center' variant='h4'>We&apos;ll Call You</Typography>
        {typeof waitTimeSeconds === 'number' ? (
          <Typography align='center'>Estimated wait time: {Math.round(waitTimeSeconds / 60) === 0 ? `${waitTimeSeconds} seconds` : `${Math.round(waitTimeSeconds / 60)} minutes`}</Typography>
        ) : (
          <Skeleton width='220px' height='24px' />
        )}
      </div>
      <Icon name='check' width={ 100 } height={ 100 } />
      <Button variant='primary' onClick={ startNewConversation }>
        Start a New Conversation
      </Button>
    </div>
  );
};
